var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1037_15176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.03125,
    y: 11.0712,
    width: 4.52487,
    height: 12.4434,
    rx: 1,
    transform: "rotate(-30 2.03125 11.0712)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.789062,
    y: 15.707,
    width: 3.39365,
    height: 5.65609,
    rx: 1,
    transform: "rotate(-30 0.789062 15.707)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.52487,
    height: 12.4434,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 15.7461 3.15259)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.39365,
    height: 5.65609,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 20.3828 4.39478)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5L15.5 10.5",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1037_15176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkout);
export default __webpack_public_path__ + "static/media/workout.d0c34c6e931691b74c5d0b2bebcee061.svg";
export { ForwardRef as ReactComponent };